export const QueryKey = {
	GET_SESSION_CONTEXT: 'GetSessionContext',
	GET_STATUS: 'GetStatus',
	GET_LOCATIONS: 'GetLocations',
};
